<template>
  <BaseModal
    v-model="isOpen"
    size="xl"
    :status="modalStatus"
    :message="modalMessage"
    :confirm-label="$t('Bokvalitetsrosen.RequestLicenseModal.confirm_button')"
    @confirm="handleSubmit"
    @cancel="handleCancel"
  >
    <template #title>
      <h2 class="text-xl font-semibold">{{ $t('Bokvalitetsrosen.RequestLicenseModal.title') }}</h2>
    </template>

    <div class="space-y-6">
      <!-- Selected Plan Info -->
      <div class="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <h3 class="font-semibold text-blue-900 mb-2">{{ $t('Bokvalitetsrosen.RequestLicenseModal.selected_plan') }}: {{ selectedPlan?.title }}</h3>
        <p class="text-blue-800 font-medium">{{ selectedPlan?.price }}</p>
        <ul class="text-sm text-blue-700 mt-2">
          <template v-for="feature in selectedPlan?.features" :key="feature">
            <li class="flex items-center" v-if="feature != ''">
              <span class="inline-block w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
              {{ feature }}
            </li>
          </template>
        </ul>
      </div>

      <!-- Explanatory Text -->
      <p class="text-gray-600">
        {{ $t('Bokvalitetsrosen.RequestLicenseModal.description') }}
      </p>

      <form @submit.prevent="handleSubmit" class="space-y-6">
        <!-- 1. Organization Information -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_title') }}</h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_name') }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.companyName"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_organization_number') }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.organizationNumber"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_type') }} <span class="text-red-500">*</span>
              </label>
              <select
                v-model="form.companyType"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_type_placeholder') }}</option>
                <option value="property">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_type_options_property') }}</option>
                <option value="architect">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_type_options_architect') }}</option>
                <option value="municipality">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_type_options_municipality') }}</option>
                <option value="other">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_company_type_options_other') }}</option>
              </select>
            </div>

            <div v-if="form.companyType === 'other'">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_other_company_type') }}
              </label>
              <input
                v-model="form.otherCompanyType"
                type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_norsk_eiendom_member') }} <span class="text-red-500">*</span>
              </label>
              <div class="space-y-2">
                <label class="flex items-center">
                  <input
                    v-model="form.norskEiendomMember"
                    type="radio"
                    value="yes"
                    class="mr-2"
                  />
                  {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_norsk_eiendom_yes') }}
                </label>
                <label class="flex items-center">
                  <input
                    v-model="form.norskEiendomMember"
                    type="radio"
                    value="no"
                    class="mr-2"
                  />
                  {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_organization_norsk_eiendom_no') }}
                </label>
              </div>
            </div>

            <!-- <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections.organization.company_size') }} <span class="text-red-500">*</span>
              </label>
              <select
                v-model="form.companySize"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections.organization.company_size_placeholder') }}</option>
                <option value="1-5">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections.organization.company_size_options.1-5') }}</option>
                <option value="6-20">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections.organization.company_size_options.6-20') }}</option>
                <option value="21-50">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections.organization.company_size_options.21-50') }}</option>
                <option value="51+">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections.organization.company_size_options.51+') }}</option>
              </select>
            </div> -->
          </div>
        </div>

        <!-- 2. Contact Person -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-2">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_contact_title') }}</h3>
          <p class="mb-4">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_contact_description') }}</p>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_contact_name') }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.contactName"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_contact_email') }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.contactEmail"
                type="email"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_contact_phone') }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.contactPhone"
                type="tel"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        <!-- 3. Billing Information -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_billing_title') }}</h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_billing_contact') }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.billingContact"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_billing_ehf_id') }}
              </label>
              <input
                v-model="form.ehfId"
                type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_billing_address') }} <span class="text-red-500">*</span>
              </label>
              <textarea
                v-model="form.billingAddress"
                required
                rows="3"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>

            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_billing_po_number') }}
              </label>
              <input
                v-model="form.poNumber"
                type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        <!-- 4. Terms and Consent -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_terms_title') }}</h3>

          <div class="space-y-3">
            <label class="flex items-start">
              <input
                v-model="form.acceptTerms"
                type="checkbox"
                required
                class="mr-3 mt-1"
              />
              <span class="text-sm">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_terms_accept_terms') }}
                <router-link
                  to="/license-terms"
                  target="_blank"
                  class="text-blue-600 hover:text-blue-800 underline"
                >
                  {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_terms_terms_link') }}
                </router-link>.
                <span class="text-red-500">*</span>
              </span>
            </label>

            <label class="flex items-start">
              <input
                v-model="form.acceptBilling"
                type="checkbox"
                required
                class="mr-3 mt-1"
              />
              <span class="text-sm">
                {{ $t('Bokvalitetsrosen.RequestLicenseModal.sections_terms_accept_billing') }} <span class="text-red-500">*</span>
              </span>
            </label>

            <p class="mt-2">{{ $t('Bokvalitetsrosen.RequestLicenseModal.sub_text') }}</p>
          </div>
        </div>
      </form>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'

export default {
  name: 'RequestLicenseModal',
  components: {
    BaseModal,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    selectedPlan: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:modelValue', 'submit'],
  data () {
    return {
      modalStatus: 'ready',
      modalMessage: '',
      form: {
        companyName: '',
        organizationNumber: '',
        companyType: '',
        otherCompanyType: '',
        norskEiendomMember: '',
        // companySize: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        billingContact: '',
        billingAddress: '',
        ehfId: '',
        poNumber: '',
        acceptTerms: false,
        acceptBilling: false,
      },
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
  methods: {
    async handleSubmit () {
      // Validate form
      if (!this.validateForm()) {
        return
      }

      this.modalStatus = 'loading'

      const requestData = {
        ...this.form,
        selectedPlan: this.selectedPlan,
      }

      await fetch(`${this.$store.state.urls.appApiRest}/license-requests`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      })

      this.modalStatus = 'success'
      this.modalMessage = this.$t('Bokvalitetsrosen.RequestLicenseModal.success_message')

      setTimeout(() => {
        this.resetForm()
      }, 3000)
    },

    handleCancel () {
      this.isOpen = false
      this.resetModalState()
    },

    validateForm () {
      // Check required fields
      const requiredFields = [
        'companyName',
        'companyType',
        'norskEiendomMember',
        // 'companySize',
        'contactName',
        'contactEmail',
        'contactPhone',
        'billingContact',
        'billingAddress',
      ]

      for (const field of requiredFields) {
        if (!this.form[field]) {
          const fieldLabel = this.$t(`Bokvalitetsrosen.RequestLicenseModal.field_labels_${field}`)
          alert(this.$t('Bokvalitetsrosen.RequestLicenseModal.validation_required_field', { field: fieldLabel }))
          return false
        }
      }

      if (this.form.companyType === 'other' && !this.form.otherCompanyType) {
        alert(this.$t('Bokvalitetsrosen.RequestLicenseModal.validation_specify_other_type'))
        return false
      }

      if (!this.form.acceptTerms || !this.form.acceptBilling) {
        alert(this.$t('Bokvalitetsrosen.RequestLicenseModal.validation_accept_terms_required'))
        return false
      }

      return true
    },

    resetForm () {
      this.form = {
        companyName: '',
        organizationNumber: '',
        companyType: '',
        otherCompanyType: '',
        norskEiendomMember: '',
        // companySize: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        billingContact: '',
        billingAddress: '',
        ehfId: '',
        poNumber: '',
        acceptTerms: false,
        acceptBilling: false,
      }
    },

    resetModalState () {
      this.modalStatus = 'ready'
      this.modalMessage = ''
    },
  },
  watch: {
    modelValue (newVal) {
      if (!newVal) {
        this.resetModalState()
      }
    },
  },
}
</script>

<style scoped>
/* Additional styling if needed */
.space-y-6 > * + * {
  margin-top: 1.5rem;
}

.space-y-4 > * + * {
  margin-top: 1rem;
}

.space-y-3 > * + * {
  margin-top: 0.75rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}
</style>
